import { Indicator, Info, Row, RowLabel, RowSublabel } from './OptionRow.styles';
import type { OptionRowProps } from './OptionRow.types';

export function OptionRow({
  label,
  sublabel,
  selected,
  onClick,
  disabled,
  mode = 'toggle',
  withIndicator = true,
  centered = false,
}: OptionRowProps) {
  return (
    <Row
      type="button"
      $selected={selected}
      onClick={onClick}
      disabled={disabled}
      role={mode === 'radio' ? 'radio' : 'checkbox'}
      aria-checked={selected}
      data-centered={centered || undefined}
    >
      {withIndicator && <Indicator $selected={selected} data-mode={mode} />}
      <Info>
        <RowLabel>{label}</RowLabel>
        {sublabel && <RowSublabel>{sublabel}</RowSublabel>}
      </Info>
    </Row>
  );
}
